import React, { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { useGetAdminDashboardMetricsQuery } from "../../graphql/generated/graphql";
import CustomText from "../../components/common/general/CustomText/CustomText";
import CustomSpacing from "../../components/common/layout/CustomSpacing/CustomSpacing";
import AdminLayout from "../../layouts/AdminLayout.web";
import AdminDashboardMetrics from "../../components/adminDashboard/AdminDashboardMetrics/AdminDashboardMetrics";
import { MotiView } from "moti";
import { useAppConfig } from "../../AppConfigProvider";
import { RolePermissions } from "../../constants/rolesAndPermissions";
import { useGetUserPermissionsQuery } from "../../graphql/generated/graphql";
import AdminRecentActivity from "../../components/adminDashboard/AdminRecentActivity/AdminRecentActivity";
import { useAuth } from "../../hooks/useAuth";
import AdminDashboardFacultyView from "./AdminDashboardFacultyView";

function AdminDashboardView() {
  const { userInfo } = useAuth();
  const appConfig = useAppConfig();
  const schoolId = appConfig.axioSchools[0];

  const { data: metricsData, loading: metricsLoading } = useGetAdminDashboardMetricsQuery({
    variables: { schoolId: schoolId || "" },
    skip: !schoolId,
  });

  const metrics = {
    totalStudents: metricsData?.getAdminDashboardMetrics?.data?.totalStudents || 0,
    activeCourses: metricsData?.getAdminDashboardMetrics?.data?.activeCourses || 0,
  };

  const isAdmin = userInfo.userPermissions.includes(RolePermissions.auditView);

  return (
    <AdminLayout withPadding={false}>
      {isAdmin ? (
        <View style={styles.pageBackground}>
          <View style={styles.contentContainer}>
            <MotiView
              from={{
                opacity: 0,
                translateY: 20,
                scale: 1,
              }}
              animate={{
                opacity: 1,
                translateY: 0,
                scale: 1,
              }}
              delay={10}
              // @ts-expect-error - transition is not typed
              transition={{ type: "timing", duration: 500 }}>
              <View style={{ flexDirection: "column", justifyContent: "flex-start" }}>
                <CustomText
                  text="Admin Dashboard"
                  size="m"
                  useTranslationText={false}
                  textType="display"
                  weight="ultraBold"
                  role="heading"
                  aria-level="1"
                  style={{ color: "#101828" }}
                />

                <CustomSpacing type="vertical" size="s" />

                <CustomText
                  text={`Welcome back, ${userInfo.userName}. Here's what's happening with your LMS today.`}
                  size="m"
                  weight="medium"
                  useTranslationText={false}
                  style={{ color: "#667085" }}
                />
              </View>
            </MotiView>

            <CustomSpacing type="vertical" size="l" />

            {!metricsLoading && schoolId && <AdminDashboardMetrics metrics={metrics} />}
            {isAdmin && <AdminRecentActivity />}
          </View>
        </View>
      ) : (
        <AdminDashboardFacultyView />
      )}
    </AdminLayout>
  );
}

const styles = StyleSheet.create({
  pageBackground: {
    flex: 1,
    backgroundColor: "#F2F4F7",
    // @ts-expect-error - works on web
    minHeight: "100vh",
  },
  contentContainer: {
    padding: 24,
    flex: 1,
  },
});

export default AdminDashboardView;
